const SETTINGS = [
  { k: "故事背景", v: "发生在现代都市「云川市」，主角是一名刚步入大学生活的普通青年，日常平淡到近乎透明，却因一场意外捡到神秘装置而改变。" },
  { k: "核心设定", v: "「恋爱辅助器」是一台能读取并量化人际关系的心形装置，以心动值、好感度与任务的方式，辅助使用者建立真实而温暖的关系。" },
  { k: "关键规则", v: "辅助器无法直接改变他人想法，它只会给出「提示」与「引导」。真正的选择权永远在主角手中——这也是漫画反复强调的价值观。" },
  { k: "隐藏代价", v: "过度依赖数值、为了任务而恋爱，会让心动值异常波动，甚至触发「心之冻结」副作用，提醒主角不要失去本心。" },
];

const WORLDS = [
  { icon: "ri-sun-line", title: "温暖日常", text: "校园、社团、深夜食堂与天台吹风，漫画用大量细腻日常撑起真实感。" },
  { icon: "ri-moon-line", title: "系统科幻", text: "在现实校园之上叠加系统科幻元素，形成「现实 × 幻想」的浪漫反差。" },
  { icon: "ri-group-line", title: "群像羁绊", text: "不止爱情，友情与亲情同样被认真刻画，让世界观更有温度与层次。" },
];

export default function WorldView() {
  return (
    <section id="world" className="relative overflow-hidden py-16 md:py-24">
      <img
        src="https://readdy.ai/api/search-image?query=Stylized%20anime%20manga%20illustration%20of%20a%20modern%20city%20skyline%20at%20warm%20golden%20hour%20with%20floating%20heart-shaped%20clouds%20and%20pink%20cherry%20blossom%20petals%20drifting%20in%20the%20wind%2C%20soft%20coral%20and%20gold%20color%20palette%2C%20dreamy%20romantic%20atmosphere%2C%20webtoon%20art%20style%2C%20clean%20detailed%20illustration%2C%20warm%20glowing%20light%2C%20no%20text&width=1600&height=900&seq=lovecomic-world&orientation=landscape"
        alt="恋爱辅助器漫画世界观背景插画，金色黄昏的都市与飘浮的爱心云朵"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/85 via-background-50/75 to-background-50/90"></div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-4 py-1.5 text-sm font-medium text-primary-700">
            <i className="ri-earth-line"></i>
            故事内核
          </span>
          <h2 className="mt-5 font-heading text-3xl leading-snug text-foreground-900 md:text-4xl">
            故事背景与<span className="text-primary-600">世界观</span>
          </h2>
          <p className="mt-4 text-base leading-relaxed text-foreground-700">
            在这座充满烟火气的都市里，恋爱辅助器带来了超现实的可能。它到底从何而来？世界又遵循着怎样的规则？一起深入这座漫画里的云川市。
          </p>
        </div>

        <div className="mt-12 grid gap-8 lg:grid-cols-2 lg:gap-12">
          <div className="space-y-4">
            {SETTINGS.map((s) => (
              <div key={s.k} className="rounded-2xl border border-background-200 bg-background-50/90 p-5 backdrop-blur-sm">
                <h3 className="flex items-center gap-2 font-heading text-lg text-primary-700">
                  <i className="ri-focus-3-line text-base"></i>
                  {s.k}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-700">{s.v}</p>
              </div>
            ))}
          </div>

          <div className="flex flex-col gap-5">
            <div className="overflow-hidden rounded-3xl">
              <img
                src="https://readdy.ai/api/search-image?query=Cozy%20anime%20manga%20scene%20of%20a%20student%20sitting%20alone%20on%20a%20rooftop%20at%20dusk%20holding%20a%20small%20glowing%20heart-shaped%20device%2C%20warm%20coral%20and%20gold%20palette%2C%20gentle%20breeze%20with%20falling%20petals%2C%20romantic%20webtoon%20art%20style%2C%20clean%20detailed%20illustration%2C%20soft%20dreamy%20lighting%2C%20no%20text&width=900&height=560&seq=lovecomic-worldcard&orientation=landscape"
                alt="恋爱辅助器漫画中主角在黄昏天台握住心形装置的场景插画"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="grid gap-4 sm:grid-cols-3">
              {WORLDS.map((w) => (
                <div key={w.title} className="rounded-2xl border border-background-200 bg-background-50/90 p-4 backdrop-blur-sm">
                  <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-secondary-100 text-secondary-700">
                    <i className={`${w.icon} text-lg`}></i>
                  </span>
                  <h4 className="mt-3 text-sm font-bold text-foreground-900">{w.title}</h4>
                  <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{w.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}